import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, ParamMap, Params, Router} from '@angular/router';
import {CustomValidators, FormsModel, Response, StaticMethods} from '../../model/GeneralModels';
import {GeneralService} from '../../services/general.service';
import {switchMap} from 'rxjs/operators';
import {AppSettingsService} from '../../services/app-settings.service';

@Component({
  selector: 'app-questions',
  templateUrl: './questions.component.html',
  styleUrls: [
    '../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css',
  ]
})
export class QuestionsComponent implements OnInit {
  forms: FormsModel[] = [];
  productName: string;
  private requestID: number;
  icon: string;
  myRequestsUrl: string;
  subset: number;
  questionsData: any;
  subRequestID: number;
  translation: any = {};

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private service: GeneralService,
              private settings: AppSettingsService) {
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.productName = params.productName;
      this.myRequestsUrl = `/${this.productName}/requests`;
      if (StaticMethods.checkState(this.router,
        ['requestID', 'formsGenerationSeed', 'icon'],
        this.myRequestsUrl)) {
        this.subset = 1;
        this.requestID = history.state.requestID;
        this.subRequestID = history.state.subRequestID;
        this.getQuestions();
        this.icon = history.state.icon;
      }
    });
  }

  getQuestions() {
    this.service.getFormQuestions(this.productName, this.subRequestID || this.requestID, this.subset)
      .subscribe((response: Response) => {
        if (response.success) {
          console.log(response);
          this.translation = StaticMethods.appendTranslation(response.translation, this.translation);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          this.questionsData = response.data;
          this.forms = [];
          if (this.subset) {
            for (const questionsDataKey in this.questionsData) {
              if (this.questionsData.hasOwnProperty(questionsDataKey)) {
                this.forms.push(new FormsModel(this.questionsData[questionsDataKey], questionsDataKey,
                  this.settings.translateEnglish(questionsDataKey, response.translation)));
              }
            }
          } else {
            this.forms[0] = new FormsModel(this.questionsData, null);
          }
        }
      });
  }

  submit() {
    const data = {};
    this.forms.forEach(form => {
      const values = form.formGroup.value;
      for (const key in values) {
        if (values.hasOwnProperty(key)) {
          data[key] = values[key];
        }
      }
    });
    const appUrl = StaticMethods.getBaseUrl(this.productName);
    this.service.submitForms(this.productName, data, this.requestID, this.subRequestID).subscribe(
      (response: Response) => {
        if (response.success) {
          if (response.data.secondFormSubmissionRequired) {
            this.getQuestions();
          } else {
            this.router.navigate([`/${appUrl}/details`], {
              state: {
                requestID: this.requestID,
                icon: this.icon
              }
            });
          }
        }
      });
  }

  checkValid() {
    if (this.forms) {
      let result = true;
      this.forms.forEach(form => {
        if (!form.formGroup.valid) {
          result = false;
          CustomValidators.markFormGroupTouched(form.formGroup);
        }
      });
      return result;
    } else {
      return false;
    }
  }
}
